<template>

<div>

  <LDBsTable
    url="permission"
    defaultSort="name"
    defaultOrder="asc"
    :query="query"
    :columns="columns"
    :clear="clear"
    :defaultOptions='options'
  >
    <div class="form-group col-lg-4">
      <label>{{ $t('name') }}</label>
      <input 
        type="text"
        class="form-control"
        id="name"
        name="name"
        :placeholder="$t('type_name')"
        v-model="query.name"
      >
    </div>

    <div class="form-group col-lg-4">
      <label>{{ $t('tag') }}</label>
      <input 
        type="text" 
        class="form-control" 
        id="tag"
        name="tag" 
        :placeholder="$t('type_tag')" 
        v-model="query.tag"
      >
    </div>

    <div class="form-group col-lg-4">
      <label for="uf">{{ $t('public') }}</label>
      <vue-select
        class="bg-white"
        name='uf'
        :placeholder="$t('select_a_item')"
        label="label"
        :options="[{ label: 'SIM', value: true }, { label: 'NÃO', value: false } ]"
        v-model="query.isPublic"
        :reduce="query => query.value"
        :select-on-tab='true'
      />
    </div>
  </LDBsTable>

</div>

</template>

<script>
import LDBsTable from '@/components/shared/LDBsTable'

export default {
  name: 'PermissionList',
  components: {
    LDBsTable
  },
  data () {
    return {
      columns: [
        {
          title: this.$t('name'),
          field: 'name',
          sortable: true
        },
        {
          title: this.$t('tag'),
          field: 'tag',
          sortable: true
        },
        {
          title: this.$t('public'),
          field: 'isPublic',
          formatter: function (value) {
            return value ? 'SIM' : 'NÃO'
          },
          sortable: true
        },
        {
          key: 'id',
          field: 'id',
          align: 'center',
          width: '100%',
          formatter: function (value) {
            return `<a href="#/main/permission/${value}" class="edit btn btn-action btn-primary btn-circle light-bottom-shadow text-white"><i class="fas fa-pen"></i></a>`
          },
        }
      ],
      options: {
        exportOptions: { fileName: 'permissoes' }
      },
      query: {
        id: '',
        name: '',
        tag: '',
        isPublic: '',
      }
    }
  },
  methods: {
    clear() {
      this.query.name = ''
      this.query.tag = ''
      this.query.isPublic = ''
    }
  }
}
</script>
